import * as tslib_1 from "tslib";
import { BaseManager } from "./base.manager";
import { LocalStorageRepositoryInterface } from "../../datastore/local/localstorage.interface";
import { PhotosphereRepositoryInterface } from "../../datastore/repositories/photosphere/photosphere.interface";
import { forkJoin, of } from "rxjs";
import { PromotionRepositoryInterface } from "../../datastore/repositories/promotion/promotion.interface";
import { ProductRepositoryInterface } from "../../datastore/repositories/product/product.interface";
import { concatMap, map } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";
var PhotosphereManager = /** @class */ (function (_super) {
    tslib_1.__extends(PhotosphereManager, _super);
    function PhotosphereManager(localStorageRepository, photosphereRepository, promotionRepository, productRepository, translate) {
        var _this = _super.call(this, localStorageRepository) || this;
        _this.localStorageRepository = localStorageRepository;
        _this.photosphereRepository = photosphereRepository;
        _this.promotionRepository = promotionRepository;
        _this.productRepository = productRepository;
        _this.translate = translate;
        return _this;
    }
    PhotosphereManager.prototype.getPhotospheres = function (pageSize, page, nurseryUUID, withNursery) {
        if (withNursery === void 0) { withNursery = false; }
        return this.photosphereRepository.getPhotospheres(pageSize, page, nurseryUUID, withNursery);
    };
    PhotosphereManager.prototype.getPhotosphereMedia = function (uuid) {
        return this.photosphereRepository.getPhotosphereMedia(uuid);
    };
    PhotosphereManager.prototype.updatePhotosphere = function (uuid, photosphere) {
        return this.photosphereRepository.updatePhotosphere(uuid, photosphere);
    };
    PhotosphereManager.prototype.associatePhotosphereProduct = function (photosphereUuid, productUuid) {
        return this.photosphereRepository.associatePhotosphereProduct(photosphereUuid, productUuid);
    };
    PhotosphereManager.prototype.disassociatePhotosphereProducts = function (photosphereUuid) {
        return this.photosphereRepository.disassociatePhotosphereProducts(photosphereUuid);
    };
    PhotosphereManager.prototype.deletePhotosphere = function (uuid) {
        return this.photosphereRepository.deletePhotosphere(uuid);
    };
    PhotosphereManager.prototype.getMarker = function (markerUUID) {
        return this.photosphereRepository.getMarker(markerUUID);
    };
    PhotosphereManager.prototype.addMarker = function (marker) {
        return this.photosphereRepository.addMarker(marker);
    };
    PhotosphereManager.prototype.updateMarker = function (markerUUID, marker) {
        return this.photosphereRepository.updateMarker(markerUUID, marker);
    };
    PhotosphereManager.prototype.deleteMarker = function (markerUUID) {
        return this.photosphereRepository.deleteMarker(markerUUID);
    };
    PhotosphereManager.prototype.getPromotions = function (pageSize, page, nurseryUuid, featured) {
        return this.promotionRepository.getPromotions(pageSize, page, nurseryUuid, featured);
    };
    PhotosphereManager.prototype.getPromotion = function (uuid) {
        return this.promotionRepository.getPromotion(uuid);
    };
    PhotosphereManager.prototype.getPromotionMedia = function (uuid) {
        return this.promotionRepository.getPromotionMedia(uuid);
    };
    PhotosphereManager.prototype.addPromotion = function (promotionType, productUUIDType, nurseryUUIDType, files) {
        var _this = this;
        var createdPromotion = null;
        return this.promotionRepository.addPromotion(promotionType, productUUIDType, nurseryUUIDType)
            .pipe(concatMap(function (promotion) {
            createdPromotion = promotion;
            return _this.uploadPromotionImage(promotion.uuid, files);
        }), map(function () { return createdPromotion; }));
    };
    PhotosphereManager.prototype.addPromotionImage = function (body, promotionUUID) {
        var formData = new FormData();
        for (var _i = 0, body_1 = body; _i < body_1.length; _i++) {
            var file = body_1[_i];
            formData.append("files", file);
        }
        return this.promotionRepository.addPromotionImage(formData, promotionUUID);
    };
    PhotosphereManager.prototype.deletePromotion = function (uuid) {
        return this.promotionRepository.deletePromotion(uuid);
    };
    PhotosphereManager.prototype.updatePromotion = function (uuid, promotionType, deletedProducts, addedProducts, deletedNurseries, addedNurseries, files) {
        var _this = this;
        return this.promotionRepository.updatePromotion(uuid, promotionType)
            .pipe(concatMap(function () { return _this.uploadPromotionImage(uuid, files); }), concatMap(function () { return _this.updatePromotionProducts(uuid, deletedProducts, addedProducts); }), concatMap(function () { return _this.updatePromotionNurseries(uuid, deletedNurseries, addedNurseries); }));
    };
    PhotosphereManager.prototype.updatePromotionProducts = function (uuid, deletedProducts, addedProducts) {
        var obs = [];
        if (addedProducts.products) {
            obs.push(this.promotionRepository.addPromotionProducts(uuid, addedProducts));
        }
        if (deletedProducts.products) {
            obs.push(this.promotionRepository.deletePromotionProducts(uuid, deletedProducts));
        }
        if (obs) {
            return forkJoin(obs);
        }
        else {
            return of();
        }
    };
    PhotosphereManager.prototype.updatePromotionNurseries = function (uuid, deletedNurseries, addedNurseries) {
        var obs = [];
        if (addedNurseries.nurseries && addedNurseries.nurseries.length > 0) {
            obs.push(this.promotionRepository.addPromotionNurseries(uuid, addedNurseries));
        }
        if (deletedNurseries.nurseries && deletedNurseries.nurseries.length > 0) {
            obs.push(this.promotionRepository.deletePromotionNurseries(uuid, deletedNurseries));
        }
        if (obs) {
            return forkJoin(obs);
        }
        else {
            return of();
        }
    };
    PhotosphereManager.prototype.uploadPromotionImage = function (promotionUuid, files) {
        /* eslint-disable dot-notation */
        if (files !== null && files["image"] && files["image"].length > 0) {
            return this.addPromotionImage(files["image"], promotionUuid);
        }
        /* eslint-enable dot-notation */
        return of({});
    };
    PhotosphereManager.prototype.syncProducts = function () {
        return this.productRepository.syncProducts();
    };
    PhotosphereManager.prototype.getProducts = function (search) {
        return this.productRepository.getProducts(search);
    };
    PhotosphereManager.prototype.getProductInfo = function (speCod, varCod) {
        var currentLang = this.translate.currentLang;
        return this.productRepository.getProductInfo(speCod, varCod, currentLang);
    };
    return PhotosphereManager;
}(BaseManager));
export { PhotosphereManager };
